// extracted by mini-css-extract-plugin
module.exports = {"container":"Breadcrumb_container__dak16","list":"Breadcrumb_list__81Sus","item":"Breadcrumb_item__SvRfd"};